













import { Component, Prop, Vue } from "vue-property-decorator";
import List from "@/components/List/List.vue";
import Table from "@/components/Table/Table.vue";
import { DataItems, DataWeeks } from "@/data.model";
import { ViewType } from "@/App.vue";

@Component({
  components: {
    List,
    Table
  }
})
export default class Views extends Vue {
  @Prop() readonly type!: ViewType;
  @Prop() readonly weeks!: DataWeeks;
  @Prop({ default: null }) readonly items!: DataItems | null;
}
